import React from 'react';
import I18n from '../../blocks/localization';

interface Props {
    titleTranslateId: string;
}

const MainContent = (props: React.PropsWithChildren<Props>) => {

    return (
        <>
            <div className='main-content'>
                <h3>{I18n.t(props.titleTranslateId)}</h3>
                {props.children}
            </div>       

            <div className='clearfix'></div>
        </>
    );
}

export default MainContent;
